/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 生成JSSDK签名
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export class CreateJsapiSignatureParams {
  constructor(public url?: string) {}
}

export default async function (
  params: CreateJsapiSignatureParams,
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: oauth2.WxJsapiSignature;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/oauth2/js-api-signature`,

    params,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
